import React, {useCallback} from 'react';
import ReactDOM from 'react-dom';
import Typography from '@material-ui/core/Typography';
import {WaypointPopupProps} from './index';
import PopupCloseButton from '../PopupCloseButton';
import WaypointStats from '../../WaypointStats';

export default function NonWritableWaypointPopup(props: WaypointPopupProps) {
    const {waypoint, onPopupChange, interaction} = props;
    const {notes, title, id} = waypoint.properties;
    const pathname = `/datasummary/waypoint/${id}/`;

    return (<div style={{maxWidth: 250}}>
        <PopupCloseButton onClick={useCallback(() => onPopupChange(undefined), [onPopupChange])} />

        <Typography variant="body1" style={{fontWeight: 'bold'}} >
            <a rel="noopener noreferrer" href={pathname}>{title}</a>
        </Typography>

        <Typography variant="caption" style={{whiteSpace: 'pre-wrap'}}>{notes}</Typography>

        <WaypointStats waypoint={waypoint} interaction={interaction} />
    </div>);
}
